import { Col, Row, Form } from 'react-bootstrap';
import { useSearchParams } from 'react-router-dom';

import { Formik } from 'formik';

import { MyNumbersFilter } from '@components/Numbers/MyNumbers/MyNumbersFilter';
import { MyNumbersTable } from '@components/Numbers/MyNumbers/MyNumbersTable';
import { numberApi } from '@reducers/number/number';

export const MyNumbers = () => {
  const [searchParams, setSearchParams] = useSearchParams();

  return (
    <Formik
      enableReinitialize
      initialValues={{
        country: searchParams.get('country') || '',
        area: searchParams.get('area') || '',
        did: searchParams.get('did') || '',
        profileName: searchParams.get('profileName') || '',
      }}
      onSubmit={() => {}}
    >
      <Form as={Row}>
        <Col md={3}>
          <MyNumbersFilter
            searchParams={searchParams}
            setSearchParams={setSearchParams}
          />
        </Col>
        <Col md={9}>
          <MyNumbersTable
            useData={numberApi.useGetCustomerNumbersQuery}
            searchParams={searchParams}
            setSearchParams={setSearchParams}
          />
        </Col>
      </Form>
    </Formik>
  );
};
